export const ONBOARDING_OPS_ROOT = '/onboarding-ops';
export const ONBOARDING_BOARD_ROUTE = '/onboarding-ops/board';
export const ABANDONED_SIGNUPS_ROUTE = '/onboarding-ops/abandoned-signups';

export const CRM_ONBOARDING_ROUTE = '/crm?tab=projects';
export const CRM_ONBOARDING_BOARD_ROUTE = '/crm?tab=projects&view=board';
export const CRM_ONBOARDING_ABANDONED_ROUTE = '/crm?tab=projects&view=abandoned';

/**
 * A lead id is absent for self-serve signups, and `String(null)` silently becomes
 * the literal "null" — which is how operators reached /crm/leads/null. These
 * helpers return null for anything unusable so callers must hide the link.
 */
export function isUsableId(value: string | null | undefined): value is string {
    if (typeof value !== 'string') return false;
    const trimmed = value.trim();
    return trimmed.length > 0 && trimmed !== 'null' && trimmed !== 'undefined';
}

export function onboardingWorkspaceRoute(leadId: string | null | undefined, workspaceId: string | null | undefined): string | null {
    if (!isUsableId(leadId) || !isUsableId(workspaceId)) return null;
    return `/crm/leads/${encodeURIComponent(leadId)}?workspace=${encodeURIComponent(workspaceId)}`;
}

export function onboardingLeadRoute(leadId: string | null | undefined): string | null {
    if (!isUsableId(leadId)) return null;
    return `/crm/leads/${encodeURIComponent(leadId)}`;
}

export function onboardingMerchantRoute(tenantId: string): string {
    return `/merchants/${encodeURIComponent(tenantId)}`;
}
